import { render, staticRenderFns } from "./AccelerometerAxisRow.vue?vue&type=template&id=3ffb6a30&scoped=true&"
import script from "./AccelerometerAxisRow.vue?vue&type=script&lang=ts&"
export * from "./AccelerometerAxisRow.vue?vue&type=script&lang=ts&"
import style0 from "./AccelerometerAxisRow.vue?vue&type=style&index=0&id=3ffb6a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb6a30",
  null
  
)

export default component.exports